// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class CrewTask_abstract extends SagaObject {
  static $t: string = 'SagaSchema.CrewTask';
  $t: string = 'SagaSchema.CrewTask';

  public static GetMembers(): string[] {
    return ['TaskUId', 'CrewUid'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return CrewTask_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public TaskUId: Guid = GuidTools.Empty;
  public CrewUid: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return this.CrewUid;
  }
  set ParentObjId(value: any) {
    this.CrewUid = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
